import { render, staticRenderFns } from "./FormCriarImplantacao.vue?vue&type=template&id=331c690e&scoped=true&"
import script from "./FormCriarImplantacao.vue?vue&type=script&lang=js&"
export * from "./FormCriarImplantacao.vue?vue&type=script&lang=js&"
import style0 from "./FormCriarImplantacao.vue?vue&type=style&index=0&id=331c690e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331c690e",
  null
  
)

export default component.exports